import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Service',
  icon: 'mdi-hand-heart-outline',
  path: '/reports/mcd/service/',
  children: [
    {
      path: '/reports/standard/service/customerFeedback',
      name: 'Customer Feedback',
      meta: { id: 'customer-recovery-dashboard' },
      component: () => import('./CustomerFeedback.vue'),
      ...addPermissionsToRoute(['CustomerFeedback']),
      tags: ['Customer Feedback'],
    },
  ]
};

export default routes;